import { crudMdActions } from "@/services/crud-md-actions";

const name = "training-course-categories";

export default {
  name,
  ...crudMdActions(name),
};
